import { render } from "./ChooseMain.vue?vue&type=template&id=4fba0bac&scoped=true"
import script from "./ChooseMain.vue?vue&type=script&lang=js"
export * from "./ChooseMain.vue?vue&type=script&lang=js"

import "./ChooseMain.vue?vue&type=style&index=0&id=4fba0bac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fba0bac"]])

export default __exports__